module.exports = __webpack_public_path__ + "img/23_23.05bf633c.png";